import { ChangeDetectionStrategy, Component, inject, input, output } from "@angular/core";
import { RouterLink } from "@angular/router";

import { ExternalLinkIconComponent } from "@components/index";
import { NavigationParams } from "@shared/services/router.service";

import { LinkService } from "./link.service";

@Component({
  selector: "app-form-link",
  templateUrl: "./form-link.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, ExternalLinkIconComponent],
  standalone: true,
})
export class FormLinkComponent {
  openInNewTab = input<boolean>(false);

  styledLink = input<boolean>(false);

  maintainFontSize = input<boolean>(false);

  link = input<NavigationParams>();

  linkClick = output();

  private readonly linkService: LinkService = inject(LinkService);

  onLinkClick(event: MouseEvent): void {
    event.stopPropagation();
    this.linkClick.emit();
    this.linkService.emitLinkClick();
  }
}
